<button type="button" class="btn btn-primary btn-square" (click)="onBrowse()">
  {{ "LABELS.BROWSE" | translate }}
</button>

<input
  #inputElement
  class="d-none"
  type="file"
  [id]="id"
  [accept]="allowedFileMimes"
  [disabled]="isDisabled"
  (change)="handleFiles($event)"
/>

<custom-toast type="alert" [message]="errorMessage" [duration]="0" [open]="isShowInvalidFileToast" (close)="onCloseInvalidFileToast()">
  <button action-button class="custom-toast__action-button btn btn-link-outlined" (click)="onReplace()">
    {{ "BUTTON.REPLACE" | translate }}
  </button>
</custom-toast>
